import {createSlice} from '@reduxjs/toolkit';

// cat. config
import {Domain} from 'config/domain';

// Create initial state from domain definitions with 1-depth flattened keys
// Result: { "user.id": "", "user.name": "", ... }
const createInitialState = () => ({
    // User info (flattened)
    ...Domain.createDefault("user", {flattenKeys: true}),

    // Profile URL (additional field)
    profileUrl: "",

    // Workspace list
    "WORKSPACE.list": [],

    // Client-side metadata
    clientUpdateDate: null,
});

const initialState = createInitialState();

const mineSlice = createSlice({
    name: 'mine',
    initialState,
    reducers: {
        /**
         * 내 정보 초기화
         * @param {Object} action.payload - 사용자 정보 객체 (flattened keys)
         */
        initMine: (state, action) => {
            return {
                ...state,
                ...action.payload,
                clientUpdateDate: new Date().toISOString()
            };
        },

        /**
         * 내 정보 업데이트
         * @param {Object} action.payload - 업데이트할 사용자 정보 (flattened keys)
         */
        updateMine: (state, action) => {
            return {
                ...state,
                ...action.payload,
                clientUpdateDate: new Date().toISOString()
            };
        },

        /**
         * 내 정보 초기화
         */
        clearMine: () => {
            return createInitialState();
        },
    },
});

export const {
    initMine,
    updateMine,
    clearMine
} = mineSlice.actions;

export default mineSlice.reducer;
